module.exports = require('./dist/cjs/src/client');
